<script>
    import api from '../../api';
    import Nota from '../../components/nota.svelte';
    export let id;

    let venta = {};
    async function traerNota() {
        const response = await api.get(`ventas/${id}/`);
        venta = { ...response.data };
    }

    $: id && traerNota();
</script>

<div class="flex mt-10">
    <div class="inline-block mx-auto">
        <Nota {...venta} />
    </div>
</div>
